import React, {Component} from "react";

import "./GlobalSearchResult.css";

class GlobalSearchResult extends Component {
	constructor(props) {
		super(props);
	}
	render() {
        let divStyle = "";
		if (this.props.image){
            divStyle = {
                backgroundImage: 'url(' + this.props.image + '?width=108)'
            }
		} else {
            divStyle = {
                backgroundImage: 'url(/UI/build/logo-dios-imagebg.svg)',
				backgroundColor: '#dedede'
            }
		}

		return (
			<li className="globalsearchresult">
				<span className="globalsearchresult-dateimagecontainer">
					<span className="globalsearchresult-dateimage" style={divStyle}></span>
				</span>
				<a href={this.props.link}>
					<h6 className="globalsearchresult-type">{this.props.type}</h6>
					<h3 className="globalsearchresult-title">{this.props.title}</h3>
					<div className="globalsearchresult-text" dangerouslySetInnerHTML={{__html: this.props.description}} />
				</a>
			</li>
		)
	}
}

export default GlobalSearchResult;



// WEBPACK FOOTER //
// ./src/js/components/GlobalSearchResult.js